import React from 'react';
import Icon, { IconName } from '../Icon';
import './BaseStats.css';

export interface BaseStat {
  value: number | string;
  label: string;
  icon: IconName;
  variant?: 'primary' | 'success' | 'warning' | 'info';
}

interface BaseStatsProps {
  stats: BaseStat[];
  className?: string;
}

const BaseStats: React.FC<BaseStatsProps> = ({ stats, className }) => {
  if (!stats?.length) {
    return null;
  }

  const containerClassName = className
    ? `base-stats ${className}`
    : 'base-stats';

  return (
    <div className={containerClassName}>
      {stats.map((stat) => {
        const { value, label, icon, variant } = stat;
        const cardClassName = variant
          ? `base-stat-card ${variant}`
          : 'base-stat-card';

        return (
          <div className={cardClassName} key={`${label}-${icon}`}>
            <Icon name={icon} className="base-stat-icon" />
            <div className="base-stat-content">
              <h3>{value}</h3>
              <p>{label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BaseStats;
